import { Component, OnInit } from '@angular/core';

import { QuickbooksService } from '../../app-lite/quickbooks/quickbooks.service';
import { MessagesService }   from '../../app-lite/messages/messages.service';

@Component({
  selector   : 'wor-quickbooks-connection',
  template: require('./quickbooks.connection.component.html')
})
export class QuickbooksConnectionComponent implements OnInit {
  title : string = this.quickbooksService.getTitle();

  constructor (
    private quickbooksService: QuickbooksService,
    private messagesService  : MessagesService
  ) {}

  ngOnInit () : void {
    Promise.resolve()
    .then(() => this.quickbooksService.isLoginReady()
      ? this.quickbooksService.login()
      : this.quickbooksService.launchSSO())
    .then(( url : string ) => window.location.assign(url))
    .catch(error => this.messagesService.error(error));
  }
}
